import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import {IconButton} from '@mui/material';
import type * as React from 'react';

type Props = {
    employeeId : number;
    isFavorite : boolean;
    onFavoriteChange : (employeeId : number, isFavorite : boolean) => void;
};

const FavoriteButton : React.FC<Props> = ({employeeId, isFavorite, onFavoriteChange} : Props) => {
    const handleUpdate = () => {
        onFavoriteChange(employeeId, !isFavorite);
    };

    return (
        <IconButton size="small" edge="start" color="inherit" onClick={handleUpdate}>
            {isFavorite ? <StarIcon fontSize="small"/> : <StarBorderIcon fontSize="small"/>}
        </IconButton>
    );
};

export default FavoriteButton;
